// import { autoType } from "d3";
import { color } from "d3";
import { container } from "../../assets/jss/dibots-global-style";

const style = theme => ({
    mainContainer: {
        position: "absolute",
        display: "flex",
        alignItems: "center",
        height: "calc(120vh - 9%)",
        top: "0",
        left: "0",
        width: "43%",
    },
    insiderHomeContainer: {
        width: "100%",
        height: "fit-content"
    },
    overflowHidden: {
        overflow: "hidden",
    },
    hiddenContainer: {
        // width: "fit-content",
        // right: "0",
        // margin: "0 auto",
        // marginLeft: "500px"
        position: "relative",
        transform: "translateY(0px)",
        height: "fit-content",
        width: "100%",
        margin: "0 auto"
    },
    searchMainContainer: {
        position: "relative",
        transform: "translateY(120px)",
        height: "fit-content",
        width: "100%",
        margin: "0 auto",
        zIndex: "1000"
    },
    smallContainer: {
        height: "fit-content !important",
        position: "relative",
        overflow: "visible !important",
        "@media (min-width: 1500px)": {
            display: "none"
        },
        "@media (max-width: 1500px)": {
            display: "flex"
        }
    },
    containerHide: {
        transform: "translateY(-1000px) !important"
    },
    searchMainContainer: {
        height: "calc(220px)",
    },
    relationshipContainer: {
        backgroundColor: "white",
        height: "100%",
        width: "100%"
    },
    connectContainer: {
        height: "300px",
        "@media (max-width: 480px)": {
            height: "250px"
        }
    },
    isFullScreen: {
        display: "none"
    },
    relationFullScreen: {
        maxWidth: "100% !important"
    },
    searchBoxContainer: {
        zIndex: "350",
        ...container,
        transition: "transform 0.5s",
        transform: "translateY(50px)"
    },
    insiderHomeSearchBoxContainer: {
        transform: "none"
    },
    hiddenSearchContainer: {
        transform: "translateY(0px)",
    },
    searchContainer: {
        zIndex: "200"
    },
    relationship: {
        zIndex: "50",
        // transform: "translateY(-100px)",
        // transform: "translateY(calc(-100%))"
        position: "absolute",
        top: "14%"
    },
    gridContainer: {
        // paddingBottom: "30px"
    },
    defaultGrid: {
        paddingBottom: "0px"
    },
    homeLogo: {
        margin: "0 auto",
        width: "480px",
        maxWidth: "100%",
        "@media (max-width: 480px)": {
            width: "100%",
        }
    },
    hiddenLogo: {
        display: "none",
    },
    home_logo: {
        fontWeight: "1000",
        display: "inline",
        textAlign: "center",
        backgroundImage: "linear-gradient(to right, #ff5c1c 0%, #ffc04b 100%)",
        color: "transparent",
        backgroundClip: "text",
        WebkitBackgroundClip: "text"
    },
    home_logo_2: {
        display: "inline",
        paddingLeft: "5.5px",
        color: "#545454",
    },
    root: {
        width: "600px",
        fontSize: "inherit",
        border: "2px solid #003663",
        transition: "all 300ms ease !important",
        margin: "0 auto",
        borderRadius: "20px",

        display: "flex",
        alignItems: "center",
        // background: "inherit",
        // color: "inherit"
    },
    insiderHomeRoot: {
        width: "100%"
    },
    rootHidden: {
        float: "left",
        width: "100%"
    },
    rootSmall: {
        display: "grid",
        top: "45px",
        position: "relative",
    },
    root__open: {
        borderTopLeftRadius: "20px !important",
        borderTopRightRadius: "20px !important",
        borderBottomLeftRadius: "0px !important",
        borderBottomRightRadius: "0px !important",
    },
    darkThemeRoot: {
        background: "#121212",
        color: "white",
        border: "1px solid white",
        "& input::-webkit-input-placeholder": { /* Chrome/Opera/Safari */
            color: "white",
        },
        "& input::-ms-input-placeholder": { /* IE 10+ */
            color: "white",
        },
        "& input::-moz-placeholder": { /* Firefox 18- */
            color: "white",
        },
    },
    container: {
        flex: "1",
        position: "relative",
        height: "inherit",
    },
    appbarSuggestion: {

        // overflow: "auto",
        margin: "-49px auto auto -1px",
        position: "fixed",
        zIndex: "200",
        width: "600px",
        border: "1px solid #003663",
        borderTop: "none",
        borderBottom: "none",
        // left: "-1px",
        // top: "45px",
    },
    suggestionsContainerOpen: {
        maxHeight: "400px",
        overflow: "auto",
        position: "absolute",
        zIndex: "200",
        width: "calc(100% + 44px)",
        left: "-2px",
        top: "30px",
        border: "2px solid #003663",
        backgroundColor: "white",
        borderRadius: "0px 0px 10px 10px",
        // marginBlockStart: "20px"
        // borderTop: "none",
    },
    suggestionsContainerOpenNotAuth: {
        maxHeight: "400px",
        overflow: "auto",
        position: "absolute",
        zIndex: "200",
        width: "calc(100% + 44px)",
        left: "-2px",
        top: "30px",
        border: "2px solid #003663",
        backgroundColor: "white",
        borderRadius: "0px 0px 10px 10px",
        // marginBlockStart: "20px"
        borderTop: "none",
    },
    smallSuggestionOpen: {
        width: "100%"
    },
    relationshipSuggestionOpen: {
        width: "calc(100% + 106px)",
    },
    marketplaceSuggestionOpen: {
        // width: "calc(100% + 53px)"
        width: "calc(100% + 44px)"
    },
    darkThemeSuggestionOpen: {
        background: "#121212",
        color: "white",
        border: "1px solid white",
        borderTop: "none"
    },
    suggestion: {
        display: "block",
    },
    suggestionsList: {
        margin: "0",
        padding: "0",
        listStyleType: "none",
        marginTop: "10px"
    },
    resultList: {
        display: "inline-flex",
        height: "inherit",
        width: "100%",
        padding: "5px 16px"
    },
    result_name: {
        flex: "1",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    result_code: {
        width: "fit-content",
    },
    highlightResult: {
        fontWeight: "900",
    },
    result: {
        fontWeight: "100",
    },
    input: {
        font: "inherit",
        color: "currentColor",
        width: "95%",
        border: "0",
        height: "inherit",
        margin: "0",
        paddingLeft: "15px",
        display: "block",
        minWidth: "0",
        boxSizing: "content-box",
        background: "none",
        webkitTapHighlightColor: "transparent",
        outline: "0",
        outlineOffset: "0",
        userSelect: "none",
    },
    icon: {
        // color: "#ffc04b",
        color: "#003663"
    },
    iconButton: {
        padding: "4px 5px",
    },
    selectedIcon: {
        opacity: "0.4",
    },
    hideIcon: {
        display: "none",
    },
    darkIcon: {
        color: "white"
    },
    iconContainer: {
        display: "flex"
    },
    smallIcon: {
        top: "-50px",
        height: "fit-content",
        position: "absolute",
        width: "fit-content",
        margin: "0 auto",
        left: "0",
        right: "0",
    },
    divider: {
        width: "1px !important",
        height: "28px !important",
        margin: "4px !important",
        backgroundColor: "#003663",
        padding: "4px 0px",
    },
    notifications: {
        zIndex: "4",
        position: "absolute",
        top: "5px",
        border: "1px solid #fff",
        right: "5px",
        fontSize: "9px",
        // background: "#ffc04b",
        background: "#003663",
        // color: "#000",
        color: "white",
        minWidth: "16px",
        height: "16px",
        borderRadius: "10px",
        textAlign: "center",
        lineHeight: "14px",
        display: "block",
        opacity: "0.8",
    },
    featureContainer: {
        marginTop: "200px",
        padding: "20px",
        display: "flex",
        alignItems: "center",
    },
    ratingTooltip: {
        color: "white",
        background: "black",
        fontSize: "14px",
        maxWidth: "300px"
    },
    ratingArrow: {
        color: "black"
    },
    darkThemeRatingTooltip: {
        background: "#121212",
        color: "white",
        fontSize: "14px",
        maxWidth: "300px"
    },
    darkThemeRatingArrow: {
        color: "#121212"
    },
    infoGrid: {
        width: "300px"
    },
    infoKey: {
        display: "inline-flex"
    },
    infoValue: {
        textAlign: "left",
    },
    innerContainer: {
        "& p": {
            marginBlockStart: "0px",
            marginBlockEnd: "0px",
        },
        width: "100%",
        display: "flex",
    },
    tabsSelected: {
        // backgroundColor: "#fff",
        color: "black",
        borderBottomStyle: "solid",
        borderBottom: "#003663",
        fontSize: "12px",
        ":: .MuiTab-textColorInherit.Mui-disabled": { opacity: 1 }
    },
    tabsNotSelected: {
        backgroundColor: "#white",
        color: "black",
        fontSize: "12px",
    },
});
export default style;